import React from 'react';
import styles from './IssueCard.module.css';

interface IssueCardProps {
  title: string;
  children: React.ReactNode;
}

export const IssueCard: React.FC<IssueCardProps> = ({ title, children }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{title}</h3>
      {children}
    </div>
  );
};
